import cx from "classnames";
import { Link, navigate } from "gatsby";
import React, { SyntheticEvent, useEffect, useState } from "react";
import search from "../images/search.svg";
import * as css from "./Search.module.css";

type Props = {
  initialQuery: string;
  numResults: number;
};

export default function Search(props: Props) {
  const [query, setQuery] = useState(props.initialQuery);

  useEffect(() => {
    setQuery(props.initialQuery);
  }, [props.initialQuery]);

  const onSubmit = async (e: SyntheticEvent) => {
    e.preventDefault();
    if (!query.length) return;
    try {
      navigate(`/?q=${query}`);
    } catch (err) {
      console.error(err);
    }
  };

  return (
    <div className={css.container}>
      <div className={css.inner}>
        <form onSubmit={onSubmit} className={css.search}>
          <img src={search} alt="" className={css.searchIcon} />
          <input
            name="query"
            placeholder="Search blogs"
            type="text"
            value={query}
            onChange={(e) => setQuery(e.target.value)}
            className={css.input}
            data-cy="blog-search-input"
          />
        </form>
        {!!props.initialQuery && (
          <Link to="/" className={css.clear} data-cy="blog-search-clear">
            &#10005;
          </Link>
        )}
      </div>
      <div
        className={cx(css.results, { [css.hideResults]: !props.initialQuery })}
        data-cy="matching-articles"
      >
        Found {props.numResults} matching article
        {props.numResults === 1 ? "" : "s"}.
      </div>
    </div>
  );
}
